<template>
  <v-container>
    <v-overlay
      absolute
      :value="splrPdLoading || fetchingSupplier"
    >
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <v-row>
      <v-col cols="12">
        <v-alert
          dense
          type="error"
          outlined
          text
          dismissible
          transition="slide-x-transition"
          class="py-0 text-uppercase"
          v-for="(item, index) in errors"
          :key="index"
        >
          {{ item[0] }}
        </v-alert>
      </v-col>
      <v-col cols="12">
        <v-autocomplete
          label="Supplier"
          v-model="supplierId"
          :items="suppliers"
          :search-input.sync="searchInput"
          item-value="id"
          no-filter
          :loading="fetchingSupplier || searchingSupplier"
        >
          <template v-slot:selection="{ item }">
            <span>{{ item.id }}</span>
            <span class="blue-grey--text mx-1 text-caption">{{ item.name }}</span>
          </template>
          <template v-slot:item="{ item }">
            <span class="blue--text">{{ item.id }}</span>
            <span class="mx-1"></span>
            <small>{{ item.name }}</small>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="12">
        <v-autocomplete
          label="Stock Code"
          :items="computedSupplierProducts"
          item-value="stock_id"
          :loading="supplierProductFetching"
          v-model="stockId"
          :disabled="!supplierId"
        >
          <template v-slot:selection="{ item }">
            <span>{{ item.stock_code }}</span>
            <span class="blue-grey--text mx-1 text-caption">{{ item.product_name }} ({{ item.brand_name }}})</span>
          </template>
          <template v-slot:item="{ item }">
            <span class="blue--text">{{ item.stock_code }}</span>
            <span class="mx-1"></span>
            <small>{{ item.product_name }} ({{ item.brand_name }})</small>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col
        cols="12"
        lg="6"
      >
        <v-text-field
          v-model="retail"
          type="number"
          :disabled="!stockId"
          label="Price"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        lg="6"
      >
        <v-text-field
          label="Quantity"
          type="number"
          v-model="quantity"
          :disabled="!stockId"
          :suffix="`/${unit}`"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-btn
          color="primary"
          dark
          :loading="updating"
          @click="update"
        >Save</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  import { mapState, mapActions } from 'vuex'
  import searchDelay from '@/extra-functions/searchDelay.extra'
  import splrPdRepository from '@/repositories/supplier-product.repository'
  import { errorHandler } from '@/extra-functions/store.extra'
  import consumerLoanInventoryRepository from '@/repositories/consumer-loan-inventory.repository'
  import { apiVars } from '@/extra-functions/api-helper.extra'

  const stockDelay = searchDelay()
  // const supplierSearchDelay = searchDelay()
  export default {
    name: 'edit-consumer-loan-inventory',
    props: {
      propConsumerId: String,
      propConsumerLoanId: String,
      propConsumerLoanInventory: Object,
    },
    data () {
      return {
        searchInput: null,
        searchingSupplier: false,
        supplierId: null,
        stockId: null,
        retail: null,
        unit: 'none',
        quantity: null,
        updating: false,
        errors: [],
        ...apiVars('splrPd'),
      }
    },
    mounted () {
      this.fetchSuppliers({ index: 0, count: 10, search: '' })
    },
    computed: {
      ...mapState({
        storeId: state => state.settings.storeId,
        suppliers: state => state.supplier.list,
        fetchingSupplier: state => state.supplier.fetching,
        // supplierProducts: state => state.supplierProduct.list,
        supplierProductFetching: state => state.supplierProduct.fetching,
        supplierProductUpdate: state => state.supplierProduct.channelUpdate,
      }),
      computedSupplierProducts () {
        return this.splrPdList
      },
      selectedStock () {
        return this.computedSupplierProducts.find(e => e.stock_id === this.stockId)
      },
    },
    watch: {
      propConsumerLoanInventory (data) {
        this.searchInput = data.supplier_id
        this.supplierId = data.supplier_id
        this.stockId = data.stock_id
        this.retail = data.retail
        this.unit = data.unit
        this.quantity = data.quantity
      },
      searchInput () {
        // this.funcSearchSupplier()
        this.getSplrPd()
      },
      supplierId (supplierId) {
        this.getSplrPd()
      },
      selectedStock (selectedStock) {
        this.retail = selectedStock.stock.retail
        this.unit = selectedStock.unit
      },
      supplierProductUpdate () {
        this.getSplrPd()
      },
    },
    methods: {
      ...mapActions({
        fetchSuppliers: 'supplier/fetch',
        // fetchSupplierProducts: 'supplierProduct/fetch',
        addConsumerLoanInventory: 'consumerLoanInventory/addToTempList',
      }),
      getSplrPd () {
        this.splrPdLoading = true
        this.splrPdErrors = []
        stockDelay(() => {
          splrPdRepository.storeList(this.supplierId, this.storeId)
            .then(({ data }) => { this.splrPdList = data })
            .catch(e => { this.splrPdErrors = errorHandler(e) })
            .then(() => { this.splrPdLoading = false })
        })
      },
      update () {
        if (!this.updating) {
          this.updating = true
          this.errors = []

          const data = {
            consumer_loan_id: this.propConsumerLoanId,
            supplier_id: this.supplierId,
            stock_id: this.stockId,
            unit: this.unit,
            retail: this.retail,
            quantity: this.quantity,
          }
          const id = this.propConsumerLoanInventory.id
          const params = {
            consumer: this.propConsumerId,
            consumerLoan: this.propConsumerLoanId,
          }
          consumerLoanInventoryRepository.update(params, { id, data })
            .then(() => { this.$emit('close-dialog') })
            .catch(e => { this.errors = errorHandler(e) })
            .then(() => { this.updating = false })
        }
      },
      // funcSearchSupplier () {
      //   this.searchingSupplier = true
      //   supplierSearchDelay(() => {
      //     this.searchingSupplier = false
      //     this.fetchSuppliers({ index: 0, count: 10, search: this.searchInput })
      //   })
      // },
      // computeSupplierProduct (e) {
      //   const stock = e.stock
      //   const unit = stock.unit
      //   let qRecieved = 0
      //   let qSale = 0
      //   let qLost = 0

      //   if (e.recieved_inventory.length) {
      //     qRecieved = e.recieved_inventory[0].quantity
      //   }

      //   if (e.sale_inventory.length) {
      //     qSale = e.sale_inventory[0].quantity
      //   }
      //   if (e.lost_inventory.length) {
      //     qLost = e.lost_inventory[0].quantity
      //   }
      //   return {
      //     ...e,
      //     unitDesc: unit.description,
      //     productName: stock.product_name,
      //     brandName: stock.brand_name,
      //     quantity: this.quantity,
      //     date_sold: this.dateTransaction,
      //     qRemaining: qRecieved - (qSale + qLost),
      //   }
      // },
    },
  }
</script>
